<template>
  <v-container fluid>
    <div id="app ">
      <v-row>
        <v-col cols="11">
          <Breadcrumb
            class="row justify-content-center mt-4"
            :crumbs="crumbs"
            @selected="selected"
          />
        </v-col>
        <v-col cols="1" v-if="showLoader">
          <LoaderProgress></LoaderProgress>
        </v-col>
      </v-row>
    </div>
    <v-row class="mt-0 border-bottom">
      <v-col>
        <newFiltercomp
          style="margin-right: 5px !important"
          :filter_data="param"
        />
      </v-col>
    </v-row>
    <v-row>
      <div
        v-if="showresult"
        style="margin-left:2%; font-weight:bold; font-size:20px; color:#0c479d"
      >
        Live Result
        <v-chip class="ma-2" color="#0c479d" label outlined>
          {{ results }}
        </v-chip>
      </div>
      <div
        v-if="showresult"
        style="margin-left:2%; font-weight:bold; font-size:20px; color:#0c479d"
      >
        Oil Name
        <v-chip class="ma-2" color="#0c479d" label outlined>
          {{ oil_name }}
        </v-chip>
      </div>
    </v-row>
    <v-row>
      <!-- height="200px"
 width=475px -->
      <div v-bind:key="val.id" v-for="val in insightsData">
        <v-row>
          <v-col v-if="showInsights">
            <v-container>
              <v-card
                id="ins1"
                class="oee-card oee-card-white card-shadow "
                height="280px"
                width="350px"
                style="overflow-y: auto; "
              >
                <v-card-text>
                  <v-row align="center">
                    <v-icon color="primary">icon-insights</v-icon>
                    <v-card-title class="pt-0 pb-0">
                      Machine Insights</v-card-title
                    >
                  </v-row>
                  <v-row align="center">
                    <div v-bind:key="epa.id" v-for="epa in val.insights">
                      <span>
                        <p>
                          <span class="insights_param"
                            >{{ epa.parameter_name }}
                          </span>
                          <span
                            v-if="'insight_type' in epa"
                            v-bind:class="{
                              insights_normal:
                                epa.insight_type == '0' ||
                                epa.insight_type == 'normal',
                              insights_alert: epa.insight_type == 'alert',
                              insights_caution: epa.insight_type == 'caution',
                            }"
                          >
                            <span>
                              {{ epa.insight_statement }}
                            </span>
                          </span>
                        </p>
                      </span>
                    </div>
                  </v-row>
                </v-card-text>
              </v-card>
              <v-card
                id="ins2"
                class="oee-card oee-card-white card-shadow "
                height="280px"
                width="500px"
                style="overflow-y: auto; "
              >
                <v-card-text>
                  <v-row align="center">
                    <v-icon color="primary">icon-insights</v-icon>
                    <v-card-title class="pt-0 pb-0">
                      Machine Insights</v-card-title
                    >
                  </v-row>
                  <v-row>
                    <div v-bind:key="epa.id" v-for="epa in val.insights">
                      <pre>
-----------------------------------------------
                      </pre>
                      <p>
                        <span
                          v-if="'insight_type' in epa"
                          class="insights_param"
                        >
                          {{ epa.parameter_name }}
                        </span>
                        <span
                          v-if="'insight_type' in epa || 'insight_type' in epa"
                          v-bind:class="{
                            insights_normal:
                              epa.insight_type == '0' ||
                              epa.insight_type == 'normal',
                            insights_alert: epa.insight_type == 'alert',
                            insights_caution: epa.insight_type == 'caution',
                          }"
                          v-html="epa.insight_statement"
                        >
                          {{ epa.insight_statement }}
                        </span>
                      </p>
                    </div>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-container>
          </v-col>
        </v-row>
      </div>
      <div v-bind:key="epak.id" v-for="epak in alertsData">
        <!-- <v-row>
          <v-col v-if="showInsights">
            <v-container>
              <v-card id="ins1" class="oee-card oee-card-white card-shadow ">
                <v-row align="center">
                  <v-icon color="primary" class="pt-3 pl-3 pb-3"
                    >icon-insights</v-icon
                  >
                  <v-card-title class=" pt-3 pl-3 pb-3">
                    Violation Trends</v-card-title
                  >
                </v-row>
                <v-row align="center" class="text-center mbN-4">
                  <v-col cols="12" sm="12" md="12" class="pr-4 pl-3 pa-1 pb-3">
                    <apexchart
                      v-bind:epak="epak"
                      type="bar"
                      height="200px"
                      width="320px"
                      :options="epak.apexchartOptions"
                      :series="epak.series"
                    ></apexchart>
                  </v-col>
                </v-row>
              </v-card>

              <v-card id="ins2" class="oee-card oee-card-white card-shadow ">
                <v-row align="center">
                  <v-icon color="primary" class="pt-3 pl-3 pb-3"
                    >icon-insights</v-icon
                  >
                  <v-card-title class=" pt-3 pl-3 pb-3">
                    Violation Trends</v-card-title
                  >
                </v-row>
                <v-row align="center" class="text-center mbN-4">
                  <v-col cols="12" sm="12" md="12" class="pr-4 pl-3 pa-1 pb-3">
                    <apexchart
                      v-bind:epak="epak"
                      type="bar"
                      height="200px"
                      width="475px"
                      :options="epak.apexchartOptions"
                      :series="epak.series"
                    ></apexchart>
                  </v-col>
                </v-row>
              </v-card>
            </v-container>
          </v-col>
        </v-row> -->
      </div>
      <div v-bind:key="apq.id" v-for="apq in apqData">
        <v-row>
          <v-col>
            <v-container>
              <v-card class="oee-card oee-card-white card-shadow">
                <v-row align="center" class="mb-2 ">
                  <v-icon
                    color="primary"
                    class="pt-3 pl-3 pb-3"
                    style="margin-bottom:-30px"
                    >{{ Changeiconaspertitle(apq.chartTitle) }}</v-icon
                  >
                  <v-card-title
                    class=" pt-3 pl-3 pb-3"
                    style="margin-bottom:-30px"
                    >{{ apq.chartTitle }}</v-card-title
                  >
                </v-row>
                <v-row align="center" class="text-center mbN-4">
                  <v-col cols="12" sm="12" md="12" class="pr-4 pl-3 pa-1 pb-3">
                    <div id="div1">
                      <apexchart
                        type="line"
                        height="200px"
                        width="475px"
                        :options="apq.chartOptions"
                        :series="apq.series"
                      ></apexchart>
                    </div>
                    <div id="div2">
                      <apexchart
                        type="line"
                        height="200px"
                        width="320px"
                        :options="apq.chartOptions"
                        :series="apq.series"
                      ></apexchart>
                    </div>
                  </v-col>
                </v-row>
              </v-card>
            </v-container>
          </v-col>
        </v-row>
      </div>
      <!-- <v-col cols="6">
        <div v-if="this.showGauge">
          <guage v-bind:gag="guageData" v-if="this.showGauge" />
        </div>
      </v-col> -->
    </v-row>

    <!-- <div>
            <v-row >
            <v-col cols="12" sm="12" md="12" >
    
                <Map_1 ref="map" :size_data="parameter" v-if='showMap'/>
      
            </v-col>
          </v-row>
    </div> -->
  </v-container>
</template>

<script>
// import guage from "../components/oilqualitygauge.vue";
import axios from "axios";
import newFiltercomp from "../components/newFiltercomp.vue";
import constants from "../constants";
import VueApexCharts from "vue-apexcharts";
import router from "../router";
import Breadcrumb from "../components/breadcrumbs.vue";
import LoaderProgress from "../components/progressLoader";
var prevNowPlaying = null;

// const chartNameMapping = constants.chartNameMapping;
export default {
  prop: ["apqData", "guageData"],
  components: {
    apexchart: VueApexCharts,
    newFiltercomp,
    // guage,
    Breadcrumb,
    LoaderProgress,
  },
  data: () => ({
    typeName: "Temperature",
    repeatMethodCall: 0,
    prevNowPlaying,
    interval_frequency: 0,
    uniqueId: "",
    recordNotFound: true,
    param: {
      showMap: false,
      parameter: [],
      machine: true,
      time_period: false,
      check: true,
      aggfunc: true,
      date: false,
      date_2: false,
      time: false,
      time2: false,
      select_1: 168,
    },
    show_oil: false,
    showresult: false,
    showLoader: false,
    crumbs: ["Home", "Environmental Monitoring"],
    alertsData: [],
    oil_name: "",
    insightsData: [],
    apqData: [],
    apqData_i: [],
    machine_id_Selected: "",
    start_date: "",
    end_date: "",
    param_grps: [],
    showInsights: false,
    results: "",
    showGauge: false,
    guageData: [],
    checkbox: false,
    oilInterval: "",
    widgets_obj_map: new Map(),
    alert_caution_map: new Map(),
    parameter_group_obj: [],
    minlist: [],
    maxlist: [],
    latestTimeStampsOfAllPlots: [],

    fromDate: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
      .toISOString()
      .substr(0, 10),
    toDate: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
      .toISOString()
      .substr(0, 10),
    menu: false,
    menu1: false,
    menu2: false,
    selectedDate: "Today",
    machinelist: ["DPIMM01", "DPIMM02", "DPIMM03", "DPIMM04", "DPIMM05"],
    dates: [],
    parameters: [],
  }),
  mounted() {
    this.machine_id_Selected = this.$route.params.macId;
  },
  beforeDestroy() {
    console.log("beforeDestroy enerrgy parameter analysis page");
    this.checkBox = false;
    this.getPeriodforSetInterval(this.machine_id_Selected);

    clearInterval(this.prevNowPlaying);
  },

  methods: {
    // assignparam(event) {
    //   // let machineID = event;
    //   let config = {
    //     method: "get",
    //     url: `${this.$config.backend_url}/getParametersData?machine_id=${event}`,
    //     headers: {
    //       Authorization: `Bearer ${sessionStorage.getItem("token")}`,
    //     },
    //   };
    //   this.noteLastAPICallTime();
    //   axios(config)
    //     .then((response) => {
    //       // console.log("response--parameter names", response.data.data);
    //       this.parameters = [];
    //       let parametersList = response.data.data;
    //       parametersList.sort((first_operator, second_operator) => {
    //         return this.compareObjects(
    //           first_operator,
    //           second_operator,
    //           "parameter_name"
    //         );
    //       });
    //       this.parameters = parametersList;
    //     })
    //     .catch((error) => {
    //       this.showLoader = false;
    //       if (error.response && error.response.status === 401) {
    //         sessionStorage.clear();
    //         router.push("/login");
    //       } else {
    //         alert("internal error");
    //         console.log("axios error", error.message);
    //       }
    //     });
    // },
    selected(crumb) {
      if (crumb === "Home") {
        if (
          `/${sessionStorage.getItem("route_first_option")}` ==
          "/environmentalMonitoring"
        ) {
          console.log(
            "Checking duplicate and proved ",
            `/${sessionStorage.getItem("route_first_option")}`
          );
        } else {
          router.push(`/${sessionStorage.getItem("route_first_option")}`);
        }
      }
      // console.log(crumb);
    },
    Changeiconaspertitle(value) {
      // console.log("checking value", value);
      if (value == "ISO Rating") return "mdi-seal";
      else if (value == "RH Data") return "icon-bolt";
      else if (value == "NAS") return "icon-bolt";
    },
    timeConverter: (UNIX_timestamp) => {
      // let a = new Date(UNIX_timestamp * 1000);
      console.log(" in time converter ", UNIX_timestamp);
      let a = new Date(UNIX_timestamp - 19800);
      console.log(" in time converter a ", a);
      let months = [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ];
      let year = a.getFullYear();
      let month = months[a.getMonth()];
      let date = a.getDate();
      let hour = a.getHours();
      let min = a.getMinutes();
      let sec = a.getSeconds();
      let time =
        date + " " + month + " " + year + " " + hour + ":" + min + ":" + sec;
      console.log(" in time converter time ", time);
      return time;
    },
    nonRealTimeData: function(machine_id, startDate, endDate, show, grp_show) {
      this.latestTimeStampsOfAllPlots.clear;
      let params = `?machine=${machine_id}&startdate=${this.start_date}&enddate=${this.end_date}&agg_function=${show}&timeframe=${grp_show}`;
      let config = {
        method: "get",
        url: `${this.$config.backend_url}/getEnvironmentalMonitoringData${params}`,
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem("token")}`,
        },
      };
      this.showMap = true; //showing map

      axios(config).then((response) => {
        try {
          console.log("actual data is ", response.data);
          this.showLoader = true;
          // if (response.data.data[0].data.latlng.length!=0){

          //     this.parameter=['500px','1020px','1040px']
          //     let latlng1 = response.data.data[0].data.latlng[response.data.data[0].data.latlng.length-1]
          //     let latlng = latlng1.split(",")
          //     let latitude =Number(latlng[0])
          //     let longitude =Number(latlng[1])
          //     this.$refs.map.methodMap(latitude, longitude);
          //     console.log("map printed")
          //   }
          //   else{

          //     console.log("map unavailable")
          //     this.parameter=['500px','1020px','1040px']
          //     this.$refs.map.methodMap(0,0);
          //   }
          // let gaugeData = response.data.data[0].data || [];
          // for (let i = 0; i < this.guageSet.length; i++) {
          //   let singleGaugeComponent = this.guageSet[i];
          //   for (let j = 0; j < gaugeData.length; j++) {
          //     let eachDataObj = gaugeData[j];
          //     if (eachDataObj.parameter_name == singleGaugeComponent.id) {
          //       singleGaugeComponent.originalValue = eachDataObj.value;
          //       let compareValue =
          //         (eachDataObj.value * 100) / singleGaugeComponent.maxValue;
          //       singleGaugeComponent.series = [compareValue];
          //       const milliseconds = eachDataObj.unix_ts;
          //       const dateObject = new Date(milliseconds);
          //       const humanDateFormat = dateObject.toLocaleString();
          //       singleGaugeComponent.timestamp = humanDateFormat;
          //     }
          //   }
          // }

          let theResultKeys = [];

          for (
            let param_grp_index = 0;
            param_grp_index < this.parameter_group_obj.length;
            param_grp_index++
          ) {
            if (
              this.parameter_group_obj[param_grp_index]["group"] == "ISO Rating"
            ) {
              let each_param_group_list = this.parameter_group_obj[
                param_grp_index
              ]["parameter_list"];
              each_param_group_list.forEach((param) => {
                //  console.log("sudheer reddy hello 3", param);
                theResultKeys.push(param.id);
              });
            }
          }
          // response.data.data[0].parameter_group.forEach((data) => {
          //   // console.log("sudheer reddy hello", data.group);
          //   if (data.group === "ISO Rating") {
          //      console.log("sudheer reddy hello 2", data.group);
          //     data.parameter_list.forEach((param) => {
          //        console.log("sudheer reddy hello 3", param);
          //       theResultKeys.push(param.id);
          //     });
          //   }
          // });
          console.log("checking resultkeys", theResultKeys);
          theResultKeys = theResultKeys.sort();

          // let theResults = [];
          // theResultKeys.forEach((key) => {
          //   let theData = response.data.data[0].data[0].data[key];
          //   theResults.push(theData[theData.length - 1].reading);
          // });
          let theString = "";
          theResultKeys.forEach((key, index) => {
            response.data.data[0].data.forEach((data) => {
              if (key == data.parameter_name) {
                if (index < theResultKeys.length - 1) {
                  theString = theString + `≥	${data.value.toFixed()}/ `;
                } else {
                  theString = theString + `≥${data.value.toFixed()} `;
                }
              }
              this.latestTimeStampsOfAllPlots.push(data.unix_ts);
              console.log("machine time is ", this.latestTimeStampsOfAllPlots);
            });
            console.log(
              "this.latestTimeStampsOfAllPlots ",
              Math.max(...this.latestTimeStampsOfAllPlots)
            );
            this.guageData["timestamp"] = this.timeConverter(
              Math.max(...this.latestTimeStampsOfAllPlots)
            );
          });

          // theResults.forEach((num, index) => {
          //   if (index < theResults.length - 1) {
          //     theString = theString + '≥	${num.toFixed()}/ ';
          //   } else {
          //     theString = theString + '≥${num.toFixed()} ';
          //   }
          // });
          this.results = theString;
          if (this.results != "") {
            this.showresult = true;
          }

          let actualData = response.data.data[0].data || {};
          for (let i = 0; i < this.apqData.length; i++) {
            let eachChartObj = this.apqData[i];
            if (Object.keys(actualData).length > 0) {
              eachChartObj.chartOptions = {
                ...eachChartObj.chartOptions,
                ...{
                  xaxis: {
                    categories: actualData["unix_ts"],
                  },
                },
              };
            }

            let seriesvalues = [];
            for (
              let param_grp_index = 0;
              param_grp_index < this.parameter_group_obj.length;
              param_grp_index++
            ) {
              if (
                this.parameter_group_obj[param_grp_index]["group"] ==
                eachChartObj.id
              ) {
                console.log(
                  "chekcib",
                  this.parameter_group_obj[param_grp_index]["group"],
                  eachChartObj.id
                );

                let each_param_group_list = this.parameter_group_obj[
                  param_grp_index
                ]["parameter_list"];
                for (
                  let param_name = 0;
                  param_name < each_param_group_list.length;
                  param_name++
                ) {
                  console.log(
                    "chyecning name",
                    each_param_group_list[param_name],
                    actualData
                  );
                  let singlValue = {
                    name: each_param_group_list[param_name]["actual_name"],
                    data: actualData[each_param_group_list[param_name]["id"]],
                  };
                  seriesvalues.push(singlValue);
                  console.log(
                    "assigning values for id ",
                    each_param_group_list[param_name]["id"],
                    singlValue
                  );
                }
              }
            }
            let alert_caution_list = this.alert_caution_map.get(
              eachChartObj.id
            );
            for (
              let seriesListindex = 0;
              seriesListindex < alert_caution_list.length;
              seriesListindex++
            ) {
              let each_list = alert_caution_list[seriesListindex];
              for (let index = 0; index < each_list.length; index++) {
                let obj = each_list[index];
                obj.data = [];
                seriesvalues.push(obj);
              }
            }
            eachChartObj.series = seriesvalues;
          }
          this.showLoader = false;
        } catch (exception) {
          this.apqData = [];
          this.guageSet = [];
          this.present = true;
          this.showLoader = false;
          console.log("error", exception);
        }
      });
    },
    getData: function(machine_id, startDate, endDate, show, grp_show) {
      this.showLoader = true;
      this.latestTimeStampsOfAllPlots.clear;

      console.log(
        "checking env",
        machine_id,
        startDate,
        endDate,
        show,
        grp_show,
        this.checkBox
      );
      // let params = `?machine=${machine_id}&startdate=${this.start_date}&enddate=${this.end_date}&agg_function=${show}&timeframe=${grp_show}`;
      console.log("checking I am in");
      // if (this.checkBox == true)
      // {

      // }
      if (this.repeatMethodCall == 0) {
        console.log("checking data,this.repeatMethodCall")
        this.repeatMethodCall += 1;
        this.nonRealTimeData(machine_id, startDate, endDate, show, grp_show);
      }
      if (this.checkBox == false) {
        this.repeatMethodCall = 0;
        console.log("checking I am in this.checkBox == false");
        this.nonRealTimeData(machine_id, startDate, endDate, show, grp_show);
      } else if (this.checkBox == true) {
        let params = `?machine=${machine_id}&startdate=${this.start_date}&enddate=${this.end_date}&agg_function=${show}&timeframe=${grp_show}`;
        let config = {
          method: "get",
          url: `${this.$config.backend_url}/getRealTimeEnergyParameterAnalysisData${params}&uniqueId=${this.uniqueId}&typeName=${this.typeName}`,
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem("token")}`,
          },
        };
        this.showMap = true; //showing map

        axios(config).then((response) => {
          try {
            console.log("checking previously assigned value", this.apqData);
            console.log(
              "actual data is ",
              response.data,
              response.data["data"]
            );
            console.log(
              "actual data is after",
              response.data,

              response.data["data"].length
            );
            if (response.data["data"] && response.data["data"].length == 0) {
              this.start_time = startDate;
              this.recordNotFound = true;
            }
            this.showLoader = true;
            // if (response.data.data[0].data.latlng.length!=0){

            //     this.parameter=['500px','1020px','1040px']
            //     let latlng1 = response.data.data[0].data.latlng[response.data.data[0].data.latlng.length-1]
            //     let latlng = latlng1.split(",")
            //     let latitude =Number(latlng[0])
            //     let longitude =Number(latlng[1])
            //     this.$refs.map.methodMap(latitude, longitude);
            //     console.log("map printed")
            //   }
            //   else{

            //     console.log("map unavailable")
            //     this.parameter=['500px','1020px','1040px']
            //     this.$refs.map.methodMap(0,0);
            //   }
            // let gaugeData = response.data.data[0].data || [];
            // for (let i = 0; i < this.guageSet.length; i++) {
            //   let singleGaugeComponent = this.guageSet[i];
            //   for (let j = 0; j < gaugeData.length; j++) {
            //     let eachDataObj = gaugeData[j];
            //     if (eachDataObj.parameter_name == singleGaugeComponent.id) {
            //       singleGaugeComponent.originalValue = eachDataObj.value;
            //       let compareValue =
            //         (eachDataObj.value * 100) / singleGaugeComponent.maxValue;
            //       singleGaugeComponent.series = [compareValue];
            //       const milliseconds = eachDataObj.unix_ts;
            //       const dateObject = new Date(milliseconds);
            //       const humanDateFormat = dateObject.toLocaleString();
            //       singleGaugeComponent.timestamp = humanDateFormat;
            //     }
            //   }
            // }
            if ( response.data["data"] && response.data["data"].length > 0) {

            let theResultKeys = [];

            for (
              let param_grp_index = 0;
              param_grp_index < this.parameter_group_obj.length;
              param_grp_index++
            ) {
              if (
                this.parameter_group_obj[param_grp_index]["group"] ==
                "ISO Rating"
              ) {
                let each_param_group_list = this.parameter_group_obj[
                  param_grp_index
                ]["parameter_list"];
                each_param_group_list.forEach((param) => {
                  //  console.log("sudheer reddy hello 3", param);
                  theResultKeys.push(param.id);
                });
              }
            }
            // response.data.data[0].parameter_group.forEach((data) => {
            //   // console.log("sudheer reddy hello", data.group);
            //   if (data.group === "ISO Rating") {
            //      console.log("sudheer reddy hello 2", data.group);
            //     data.parameter_list.forEach((param) => {
            //        console.log("sudheer reddy hello 3", param);
            //       theResultKeys.push(param.id);
            //     });
            //   }
            // });
            console.log("checking resultkeys", theResultKeys);
            theResultKeys = theResultKeys.sort();

            // let theResults = [];
            // theResultKeys.forEach((key) => {
            //   let theData = response.data.data[0].data[0].data[key];
            //   theResults.push(theData[theData.length - 1].reading);
            // });
            let theString = "";
            theResultKeys.forEach((key, index) => {
              response.data.data[0].data.forEach((data) => {
                if (key == data.parameter_name) {
                  if (index < theResultKeys.length - 1) {
                    theString = theString + `≥	${data.value.toFixed()}/ `;
                  } else {
                    theString = theString + `≥${data.value.toFixed()} `;
                  }
                }
                this.latestTimeStampsOfAllPlots.push(data.unix_ts);
                console.log(
                  "machine time is ",
                  this.latestTimeStampsOfAllPlots
                );
              });
              console.log(
                "this.latestTimeStampsOfAllPlots ",
                Math.max(...this.latestTimeStampsOfAllPlots)
              );
              this.guageData["timestamp"] = this.timeConverter(
                Math.max(...this.latestTimeStampsOfAllPlots)
              );
            });

            // theResults.forEach((num, index) => {
            //   if (index < theResults.length - 1) {
            //     theString = theString + '≥	${num.toFixed()}/ ';
            //   } else {
            //     theString = theString + '≥${num.toFixed()} ';
            //   }
            // });
            this.results = theString;
            if (this.results != "") {
              this.showresult = true;
            }

            let actualData = response.data.data[0].data || {};
            for (let i = 0; i < this.apqData.length; i++) {
              let eachChartObj = this.apqData[i];
              if (Object.keys(actualData).length > 0) {
                console.log("checking unix and categoires",eachChartObj.chartOptions.xaxis.categories,actualData["unix_ts"])
                let value = actualData["unix_ts"].concat(eachChartObj.chartOptions.xaxis.categories
                   || []
                );
                console.log("after concatenation",value)
                eachChartObj.chartOptions = {
                  ...eachChartObj.chartOptions,
                  ...{
                    xaxis: {
                      categories: value,
                    },
                  },
                };
              }

              let seriesvalues = [];
              for (
                let param_grp_index = 0;
                param_grp_index < this.parameter_group_obj.length;
                param_grp_index++
              ) {
                if (
                  this.parameter_group_obj[param_grp_index]["group"] ==
                  eachChartObj.id
                ) {
                  console.log(
                    "chekcib",
                    this.parameter_group_obj[param_grp_index]["group"],
                    eachChartObj.id
                  );

                  let each_param_group_list = this.parameter_group_obj[
                    param_grp_index
                  ]["parameter_list"];
                  for (
                    let param_name = 0;
                    param_name < each_param_group_list.length;
                    param_name++
                  ) {
                    let data =
                      // eachChartObj[param_name].data.concat(

                      actualData[each_param_group_list[param_name]["id"]] || [];

                    data =
                      each_param_group_list[param_name]["actual_name"] ==
                      eachChartObj.series[param_name]["name"]
                        ? actualData[each_param_group_list[param_name]["id"]].concat(
                          eachChartObj.series[param_name]["data"]
                          )
                        : actualData[each_param_group_list[param_name]["id"]];
                    console.log("chyecning name", data);
                    let singlValue = {
                      name: each_param_group_list[param_name]["actual_name"],
                      data: data,
                    };
                    seriesvalues.push(singlValue);
                    console.log(
                      "assigning values for id ",
                      each_param_group_list[param_name]["id"],
                      singlValue
                    );
                  }
                }
              }
              let alert_caution_list = this.alert_caution_map.get(
                eachChartObj.id
              );
              for (
                let seriesListindex = 0;
                seriesListindex < alert_caution_list.length;
                seriesListindex++
              ) {
                let each_list = alert_caution_list[seriesListindex];
                for (let index = 0; index < each_list.length; index++) {
                  let obj = each_list[index];
                  obj.data = [];
                  seriesvalues.push(obj);
                }
              }
              eachChartObj.series = seriesvalues;
            }
          }
            this.showLoader = false;
          } catch (exception) {
            this.apqData = [];
            this.guageSet = [];
            this.present = true;
            this.showLoader = false;
            console.log("error", exception);
          }
        });
      }
    },
    getPeriodforSetInterval: function(machine_id) {
      let params = "";
      this.showLoader = true;

      console.log("checking checkbox", this.checkBox);
      params = `?machine=${machine_id}&activeStatus=${this.checkBox}&uniqueId=${this.uniqueId}&typeName=${this.typeName}`;

      let config = {
        method: "get",
        url: `${this.$config.backend_url}/getPeriodForSetInterval${params}`,
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem("token")}`,
        },
      };
      this.noteLastAPICallTime();
      axios(config)
        .then((response) => {
          console.log("response", response.data["data"], machine_id);
          this.uniqueId = response.data["data"][1] || "";

          if (
            this.uniqueDataList &&
            !this.uniqueDataList.includes(this.uniqueId)
          ) {
            console.log(
              "checking previous and now",
              this.previousUniqueId,
              this.uniqueId
            );
            this.uniqueDataList.push(this.uniqueId);
          }
          console.log(
            "checking unique data list",
            this.uniqueDataList,
            this.uniqueId
          );
          sessionStorage.setItem("storedUniqueList", this.uniqueDataList);
          this.interval_frequency = response.data["data"][0];
          console.log(
            "Checking this.$config.extensionOfSetIntervalSeconds",
            this.$config.extensionOfSetIntervalSeconds,
            typeof this.$config.extensionOfSetIntervalSeconds,
            typeof (response.data["data"][0] * 1000)
          );
          response.data["data"][0] * 1000 +
          this.$config.extensionOfSetIntervalSeconds
            ? response.data["data"]
            : this.$config.extensionOfSetIntervalSeconds;

          console.log(
            "checking setinterval after receiving response",
            this.interval_frequency
          );
        })
        .catch();
    },
    getRealTimeEnergyData: function(
      machine_id,
      startDate,
      endDate,
      show,
      grp_show
    ) {
      this.getData(machine_id, startDate, endDate, show, grp_show);
    },
    searchNew: function(machine_id, startDate, endDate, show, grp_show, check) {
      this.start_date = startDate;
      this.end_date = endDate;
      // document.querySelector("#warningAlert").style.display = "none";
      this.machine_id_Selected = machine_id;
      let params = "";
      // document.querySelector("#loaderStyle").style.display = "block";
      this.showLoader = true;

      if (this.start_date == "") {
        params = `?machine=${machine_id}`;
      } else {
        params = `?&machine=${machine_id}&startdate=${this.start_date}&enddate=${this.end_date}&agg_function=${show}&timeframe=${grp_show}`;
      }
      let config = {
        method: "get",
        url: `${this.$config.backend_url}/getEnvSetup${params}`,
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem("token")}`,
        },
      };
      this.noteLastAPICallTime();
      axios(config)
        .then((response) => {
          if (response.data.data != []) {
            this.showInsights = false;
            this.showGauge = false;
          }
          try {
            this.widgets_obj_map.clear();
            let condemn_list =
              response.data.data[0].condemning_limit_list || [];
            let alerts_stack_data = response.data.data[0].alerts_data || [];
            let oil_name_m = response.data.data[0].oil_name || "Mobil";
            let avg_date_str = response.data.data[0].avg_date_str;
            let avg_alerts_empty = response.data.data[0].avg_alerts_empty;

            // console.log("checking oil name",oil_name_m);

            this.oil_name = oil_name_m || "Mobil";
            if (this.oil_name != "") {
              this.show_oil = true;
            }
            // console.log("Checking alerts stack data",alerts_stack_data);
            let dates = alerts_stack_data[1] || [];
            let stack_dic = alerts_stack_data[0] || [];
            let params_list = alerts_stack_data[2] || [];
            console.log("checking dates and stack data", dates, stack_dic);
            let parameter_value_all_month = [];
            let total_params = [];
            // this.alertsData = [];
            for (let k = 0; k < params_list.length; k++) {
              console.log(
                "Checking parameter ids",
                params_list[k],
                stack_dic,
                stack_dic.length
              );

              for (let j = 0; j < stack_dic.length; j++) {
                for (let i = 0; i < dates.length; i++) {
                  {
                    if (
                      dates[i] == stack_dic[j]["date"] &&
                      stack_dic[j]["parameter_id"] == params_list[k]
                    ) {
                      parameter_value_all_month.push(stack_dic[j]["count"]);
                    }
                  }
                }
              }
              let param_name = "";
              for (let i = 0; i < this.parameters.length; i++) {
                if (this.parameters[i]["parameter_id"] === params_list[k]) {
                  param_name = this.parameters[i]["parameter_name"];
                  console.log(
                    "Checking after coniditon statisfied",
                    param_name
                  );
                }
              }
              console.log("Checking out of condition", param_name);
              let dicData = {
                name: param_name,
                data: parameter_value_all_month,
              };
              total_params.push(dicData);
              parameter_value_all_month = [];
            }

            if (avg_alerts_empty == true) {
              for (let i = 0; i < total_params.length; i++) {
                total_params[i]["data"].unshift(0);
              }
              dates.unshift(avg_date_str);
            } else {
              dates[0] = avg_date_str;
            }

            // console.log("checking result of all params",total_params,dates);

            let chartData = {
              id: 1,
              series: total_params,
              chartTitle: "Apex",
              dataLabels: { enabled: false },

              apexchartOptions: {
                series: total_params,
                zoom: {
                  enabled: true,
                  autoScaleYaxis: true,
                },
                chart: {
                  type: "bar",

                  height: "200px",
                  stacked: true,
                  toolbar: {
                    show: true,

                    autoSelected: "zoom",
                  },

                  zoom: {
                    enabled: true,
                    autoScaleYaxis: true,
                  },
                },
                responsive: [
                  {
                    breakpoint: 480,
                    options: {
                      legend: {
                        position: "right",
                        showForSingleSeries: true,
                        offsetY: 40,
                      },
                    },
                  },
                ],
                plotOptions: {
                  bar: {
                    horizontal: false,
                    borderRadius: 2,
                    columnWidth: "20%",
                  },
                },
                yaxis: {
                  decimalsInFloat: 0,
                  forceNiceScale: true,
                  // tickAmount: 2,
                  labels: {
                    // formatter: function (val) {
                    //   return parseInt(val) === val ? val : ''
                    // }
                    formatter: function(val) {
                      return val;
                    },
                    // formatter: (value) => Math.floor(value),
                  },
                  title: {
                    text: "Violations Count",

                    // style: {
                    //   color: "#484848",
                    //   fontFamily: "EMPrint",
                    //   fontSize: "16px",
                    //   fontWeight: "bold",
                    // },
                  },
                },

                xaxis: {
                  type: "string",
                  categories: dates,
                  convertedCatToNumeric: false,
                  title: {
                    text: "Time",
                    align: "right",
                    offsetY: -10,

                    style: {
                      color: "#484848",
                      fontSize: "14px",
                      fontWeight: "bold",
                    },
                  },
                  axisBorder: {
                    show: true,
                    color: "#78909C",
                    height: 1,
                    width: "100%",
                    offsetX: 0,
                    offsetY: 0,
                  },
                },
                legend: {
                  position: "top",
                  horizontalAlign: "center",
                  marginLeft: "-10px",
                  showForSingleSeries: true,
                  markers: { radius: 12 },

                  // offsetY: -10
                  //  style: {
                  //    offsetY:"-10px"
                  //  }
                },
                fill: {
                  opacity: 1,
                },
              },
            };
            // console.log("checking result of all params",total_params,dates);

            // this.alertsData = [];
            let add = [];
            add.push(chartData);
            // console.log("checking lsit aft",add);

            this.alertsData = add || [];
            // console.log("checking apexcharts",this.alertsData);

            let data = response.data.data[0];
            let parameter_group = data.parameter_group;
            this.parameter_group_obj = data.parameter_group;

            for (
              let param_grp_index = 0;
              param_grp_index < parameter_group.length;
              param_grp_index++
            ) {
              let id = -1;
              let minList = [];
              let maxList = [];
              let chartMinMaxObj = {};
              let dbc_params_map = new Map();
              let each_param_group_list =
                parameter_group[param_grp_index]["parameter_list"];
              let group_name = parameter_group[param_grp_index]["group"];
              let widget_type_name =
                parameter_group[param_grp_index]["widget_name"];

              console.log("checking param list group_name", group_name);
              if (!this.widgets_obj_map.has(widget_type_name)) {
                this.widgets_obj_map.set(widget_type_name, []);
              }
              const widgets_list = this.widgets_obj_map.get(widget_type_name);

              let chart_data_list = [];

              for (
                let param_grp_list_index = 0;
                param_grp_list_index < each_param_group_list.length;
                param_grp_list_index++
              ) {
                let param_actual_name =
                  each_param_group_list[param_grp_list_index]["actual_name"];
                let component_name =
                  each_param_group_list[param_grp_list_index]["name"];
                var maxValue = "";
                var minValue = "";
                id = each_param_group_list[param_grp_list_index]["id"];
                console.log(" param_actual_name is ", param_actual_name);
                console.log(" param_display_name is ", component_name);
                var timestamp = "";
                var originalValue = "";
                if (
                  each_param_group_list[param_grp_list_index]["db_parameters"]
                ) {
                  maxValue =
                    each_param_group_list[param_grp_list_index]["db_parameters"]
                      .max_value;
                  minValue =
                    each_param_group_list[param_grp_list_index]["db_parameters"]
                      .min_value;

                  maxList.push(maxValue);
                  minList.push(minValue);
                  dbc_params_map.set(
                    param_actual_name,
                    each_param_group_list[param_grp_list_index]["db_parameters"]
                  );
                }

                console.log("checking min and max", minValue, maxValue);
                var series = [0];
                let width = "100%";
                let maxwidth = "155px";
                let maxheight = "200px";

                if (widget_type_name == "Digital Gauge") {
                  let singleComponent = {
                    id,
                    originalValue,
                    component_name,
                    maxheight,
                    maxwidth,
                    series,
                    width,
                    timestamp,
                    minValue,
                    maxValue,
                  };
                  widgets_list.push(singleComponent);
                } else if (widget_type_name == "Line Chart") {
                  let singlValue = {
                    name: param_actual_name,
                    data: [],
                  };
                  chart_data_list.push(singlValue);
                }
              }
              chartMinMaxObj = {
                minvalue: Math.min(...minList),
                maxvalue: Math.max(...maxList),
              };

              if (widget_type_name == "Line Chart") {
                let finalData = this.finalizeDataNew(
                  chart_data_list,
                  group_name,
                  condemn_list,
                  chartMinMaxObj,
                  dbc_params_map
                );

                widgets_list.push(finalData[0]);
                this.alert_caution_map.set(group_name, finalData[1]);
              }
            }

            if (this.widgets_obj_map.has("Digital Gauge")) {
              this.guageSet = this.widgets_obj_map.get("Digital Gauge");
            }
            if (this.widgets_obj_map.has("Line Chart")) {
              this.apqData = this.widgets_obj_map.get("Line Chart");
            }
            this.showInsights = true;
            let machineinsights = response.data.data[0].machine_insights || [];

            console.log("checking machine insights", machineinsights);
            this.insightsData = [{ id: 1, insights: machineinsights }] || [];

            this.present = false;

            this.getData(
              this.machine_id_Selected,
              startDate,
              endDate,
              show,
              grp_show,
              check
            );

            // let theResultKeys = [];
            // response.data.data[0].parameter_group.forEach((data) => {
            //   // console.log("sudheer reddy hello", data.group);
            //   if (data.group === "ISO Rating") {
            //      console.log("sudheer reddy hello 2", data.group);
            //     data.parameter_list.forEach((param) => {
            //        console.log("sudheer reddy hello 3", param);
            //       theResultKeys.push(param.id);
            //     });
            //   }
            // });
            // console.log("checking resultkeys",theResultKeys);
            // theResultKeys = theResultKeys.sort();
            // let theResults = [];
            // theResultKeys.forEach((key) => {
            //   let theData = response.data.data[0].data[0].data[key];
            //   theResults.push(theData[theData.length - 1].reading);
            // });
            // let theString = "";
            // theResults.forEach((num, index) => {
            //   if (index < theResults.length - 1) {
            //     theString = theString + `≥	${num.toFixed()}/ `;
            //   } else {
            //     theString = theString + `≥${num.toFixed()} `;
            //   }
            // });
            // this.results = theString ;
            // if  (this.results != "")
            // {
            //   this.showresult = true;

            // }
            // let sanitisedData = this.sanitisedDataNew(
            //   response.data.data[0].data[0].data,
            //   "",
            //   response.data.data[0].parameter_group
            // );
            //   let latestTimeStamp = (data)=>{
            //   let theData = data;
            //   let allLastTimeStamps = [];
            //   for(let each in theData){
            //     // eslint-disable-next-line no-prototype-builtins
            //     if(theData.hasOwnProperty(each) && typeof theData[each] === "object"){
            //       allLastTimeStamps.push(theData[each].pop().unix_time)
            //     }
            //   }
            //   return allLastTimeStamps;
            // };
            //           let latestTimeStampsOfAllPlots = latestTimeStamp(response.data.data[0].data[0].data)
            //           {
            //             {
            //               {
            //                 let finalData = this.finalizeDataNew(
            //                   sanitisedData,
            //                   response.data.data[0].parameter_group,
            //                   "",
            //                   condemn_list
            // );
            //                 this.showInsights = true;
            //                 this.apqData = finalData[0];
            //                 let parameterGroup = response.data.data[0].parameter_group;
            //                 let machineinsights = response.data.data[0].machine_insights;
            //                 let presetParameterList = [];
            //                 // console.log("chekcing final data 2=>", finalData[1]);
            //                 for (let i = 0; i < finalData[1].length; i++) {
            //                   // console.log("checking final data each=>", finalData[1][i]);
            //                   presetParameterList.push(finalData[1][i].parameter_name);
            //                 }
            //                 // console.log(
            //                 //   "checking total present  list=>",
            //                 //   presetParameterList
            //                 // );
            //                 for (let i = 0; i < machineinsights.length; i++) {
            //                   for (let j = 0; j < parameterGroup.length; j++) {
            //                     for (
            //                       let _m = 0;
            //                       _m < parameterGroup[j].parameter_list.length;
            //                       _m++
            //                     ) {
            //                       if (
            //                         parameterGroup[j].parameter_list[_m].name ==
            //                           machineinsights[i].parameter_name &&
            //                         machineinsights[i].parameter_name != "low_caution" &&
            //                         machineinsights[i].parameter_name != "high_caution"
            //                       ) {
            //                         for (let c_l = 0; c_l < condemn_list.length; c_l++) {
            //                           // console.log("checking codemning list=>",condemn_list[c_l]);
            //                           if (
            //                             condemn_list[c_l].parameter_name == machineinsights[i].parameter_name
            //                           ) {
            //                             machineinsights[i].high_alert =
            //                               condemn_list[c_l].high_alert;
            //                             machineinsights[i].low_alert =
            //                               condemn_list[c_l].low_alert;
            //                           }
            //                         }
            //                       }
            //                     }
            //                   }
            //                 }
            //                 // console.log(
            //                 //   "checking insights from api part3",
            //                 //   machineinsights
            //                 // );
            //                 for (let i = 0; i < machineinsights.length; i++) {
            //                   for (let j = 0; j < parameterGroup.length; j++) {
            //                     for (
            //                       let _m = 0;
            //                       _m < parameterGroup[j].parameter_list.length;
            //                       _m++
            //                     ) {
            //                       if (
            //                         parameterGroup[j].parameter_list[_m].name ==
            //                         machineinsights[i].parameter_name
            //                       ) {
            //                         for (let f_l = 0; f_l < finalData[1].length; f_l++) {
            //                           if (
            //                             parameterGroup[j].parameter_list[_m].name ==
            //                             finalData[1][f_l].parameter_name
            //                           ) {
            //                             machineinsights[i].max =
            //                               finalData[1][f_l].reading;
            //                               if(machineinsights[i].status == "OK")
            //                               {
            //                                machineinsights[i].current =  finalData[1][f_l].reading;
            //                               }
            //                             // machineinsights[i].current_time =
            //                             //   finalData[1][f_l].current_time;
            //                           }
            //                         }
            //                       }
            //                     }
            //                   }
            //                 }
            //                 // console.log(
            //                 //   "checking insights from api part1",
            //                 //   machineinsights
            //                 // );
            //                 for (let m_i = 0; m_i < machineinsights.length; m_i++) {
            //                   if (machineinsights[m_i].status == "high_alert") {
            //                     machineinsights[m_i].status = "High";
            //                   } else if (machineinsights[m_i].status == "low_alert") {
            //                     machineinsights[m_i].status = "Low";
            //                   } else if (machineinsights[m_i].status == "OK") {
            //                     // console.log("checking machine insights in OK=>",machineinsights[m_i]);
            //                     machineinsights[m_i].status = "Normal";
            //                   }
            //                     else  if (machineinsights[m_i].status == "low_caution") {
            //                     machineinsights[m_i] = {};
            //                   } else  if (machineinsights[m_i].status == "high_caution") {
            //                     machineinsights[m_i] = {};
            //                   }
            //                 }
            //                 // console.log("checking insights from api", machineinsights);
            //                 let uniqueChars = [];
            //                 // $.each(machineinsights, function(i, el) {
            //                 //   if ($.inArray(el.parameter_name, uniqueNames) === -1) uniqueNames.push(el);
            //                 // });
            //                 // console.log("checking unique",uniqueNames);
            //                 machineinsights.forEach((i) => {
            //                   if (!uniqueChars.includes(i.id)) {
            //                     uniqueChars.push(i);
            //                   }
            // });
            let timeStamp = this.timeConverter(this.end_date);
            let total_up_time_details =
              response.data.data[0].machine_up_time[0] || [];
            // console.log(
            //   "checking finally before ordering insights=>",
            //   uniqueChars
            // );
            if (
              total_up_time_details.total_minutes != null &&
              total_up_time_details.avg_minutes != null
            ) {
              this.showGauge = true;

              let hours = Math.floor(total_up_time_details.total_minutes / 60);
              let minutes = total_up_time_details.total_minutes % 60;
              let curr_value = hours + " Hrs :" + minutes + " Mins";
              // console.log(
              //   " total up time details ",
              //   total_up_time_details.total_minutes,
              //   "checking machine uotime frotval",response.data.data[0].machine_up_time[0]
              // );
              let machineUpTime =
                response.data.data[0].machine_up_time[0] || [];
              machineUpTime.timestamp = timeStamp;
              // console.log("checking up time=>",machineUpTime);
              let start = this.start_date;
              if (this.end_date - this.start_date == 3600) {
                // console.log("checki diff=>",this.end_date - this.start_date);
                let d = new Date();
                start = d.setHours(0, 0, 0, 0) / 1000;
              }
              console.log("checki g start=>", start, this.end_date);
              let totalTime = (this.end_date - start) / 60;
              hours = Math.floor(totalTime / 60);
              minutes = totalTime % 60;
              let maxValue = hours + " Hrs :" + minutes.toFixed() + " Mins";

              let series = (
                (machineUpTime.total_minutes / totalTime) *
                100
              ).toFixed(2);
              machineUpTime.width = "100%";
              let maxwidth = "510px";
              let maxlength = "280px";
              this.guageData = {
                component_name: "Machine Up Time",
                width: "100%",
                maxwidth: maxwidth,
                maxheight: maxlength,
                minValue: "00 Hrs: 00 Mins",
                isEnergy: "false",
                maxValue: maxValue,
                originalValue: curr_value,
                series: [series],
                id: 1,
                timestamp: this.timeConverter(this.end_date),
                // timestamp: 0,
              };
            } else if (
              total_up_time_details.total_minutes == null &&
              total_up_time_details.avg_minutes == null
            ) {
              this.showGauge = true;
              let machineUpTime = {};
              machineUpTime.timestamp = timeStamp;
              let curr_value = "0 Hrs :" + "0 Mins";
              machineUpTime.width = "100%";
              let maxwidth = "460px";
              let maxlength = "270px";
              this.guageData = {
                component_name: "Machine Up Time",
                width: "100%",
                maxwidth: maxwidth,
                maxheight: maxlength,
                originalValue: curr_value,
                series: [0],
                id: 1,
                timestamp: this.timeConverter(
                  Math.max(...this.latestTimeStampsOfAllPlots)
                ),
                // timestamp: 0,
              };
              console.log(
                "checking Math.max(...this.latestTimeStampsOfAllPlots)=>",
                Math.max(...this.latestTimeStampsOfAllPlots)
              );
            }
            //                 let eligibleInsight = [];
            //                 for (let i = 0; i < uniqueChars.length; i++) {
            //                   // console.log(
            //                   //   "checking ewhete is ther",
            //                   //   uniqueChars[i].parameter_name,
            //                   //   presetParameterList
            //                   // );
            //                   if (
            //                     presetParameterList.includes(
            //                       uniqueChars[i].parameter_name
            //                     ) == true
            //                   ) {
            //                     eligibleInsight.push(uniqueChars[i]);
            //                   }
            //                 }
            //                 // console.log("eligible insights are=>", eligibleInsight);
            //                 // console.log(
            //                 //   "checking finally before assigningand after ordering insights=>",
            //                 //   eligibleInsight
            //                 // );
            //                 let value = {
            //                   id: 1,
            //  insights:eligibleInsight
            //                 }
            //                 this.insightsData = [value] || [[]];
            //               }
            //             }
            //             // document.querySelector("#loaderStyle").style.display = "none";
            //           }
            // this.showLoader = false;
          } catch (exception) {
            // document.querySelector("#loaderStyle").style.display = "none";
            this.showLoader = false;

            // document.querySelector("#warningAlert").style.display = "block";
            this.apqData = [];
            console.log("error", exception);
          }
        })
        .catch((error) => {
          this.showLoader = false;

          if (error.response && error.response.status === 401) {
            sessionStorage.clear();
            router.push("/login");
          } else {
            alert("internal error");
            console.log("axios error", error.message);
          }
        });
    },
    sanitisedDataNew: (data, paramNames, category) => {
      let chartsGroupList = [];
      for (let i = 0; i < category.length; i++) {
        let singleMachineAPQ = {
          id: category[i].group,
          data: {},
        };
        let eachParameterList = category[i].parameter_list;
        for (let j = 0; j < eachParameterList.length; j++) {
          let eachParamNameDict = eachParameterList[j];
          let eachParamData = data[eachParamNameDict.id];
          if (eachParamData != undefined) {
            singleMachineAPQ.data[eachParamNameDict.name] = eachParamData;
          }
        }
        chartsGroupList.push(singleMachineAPQ);
      }
      return chartsGroupList;
    },
    finalizeDataNew: (
      seriesvalues,
      chartname,
      condemn_list,
      chartMinMaxObj,
      dbc_params_map
    ) => {
      console.log(
        "checking seriesvalues=>",
        seriesvalues,
        "chart names=>",
        chartname,
        "condemn_list =>",
        condemn_list,
        "dbc_params_map",
        dbc_params_map
      );
      console.log("chartMinMaxObj ist", chartMinMaxObj);
      let checkin = "";
      let lowAlertlist = [];
      let highAlertlist = [];
      let lowCautionlist = [];
      let highCautionlist = [];

      for (let i = 0; i < condemn_list.length; i++) {
        if (condemn_list[i].group_name == chartname) {
          checkin = condemn_list[i];
          if (checkin.high_alert != "null") {
            highAlertlist.push(checkin.high_alert);
          }
          if (checkin.low_alert != "null") {
            lowAlertlist.push(checkin.low_alert);
          }
          if (checkin.high_caution != "null") {
            highCautionlist.push(checkin.high_caution);
          }
          if (checkin.low_caution != "null") {
            lowCautionlist.push(checkin.low_caution);
          }
        }
      }
      let lowAlertValue = Math.min(...lowAlertlist);
      let highAlertValue = Math.max(...highAlertlist);
      let lowCautionValue = Math.min(...lowCautionlist);
      let highCautionValue = Math.max(...highCautionlist);

      console.log("lowCautionValue confirm", lowCautionValue);
      console.log("highAlertValue confirm", highAlertValue);
      let lowAlertChart = {
        name: "Alert",
        data: [lowAlertValue],
      };
      let lowCautionChart = {
        name: "Caution",
        data: [lowCautionValue],
      };
      let highAlertChart = {
        name: "Alert",
        data: [highAlertValue],
      };
      let highCautionChart = {
        name: "Caution",
        data: [highCautionValue],
      };
      let alertsValues = [];
      let cautionsValues = [];

      console.log("cehcking alerts", checkin.low_alert, checkin.high_alert);
      if (isFinite(lowAlertValue)) {
        alertsValues.push(lowAlertChart);
      }
      if (isFinite(highAlertValue)) {
        alertsValues.push(highAlertChart);
      }

      if (isFinite(lowCautionValue)) {
        cautionsValues.push(lowCautionChart);
      }
      if (isFinite(highCautionValue)) {
        cautionsValues.push(highCautionChart);
      }

      console.log("checking alerts array", highAlertChart, alertsValues);

      seriesvalues = seriesvalues.concat(alertsValues);
      seriesvalues = seriesvalues.concat(cautionsValues);
      console.log("checking seriveValuies", seriesvalues);
      let alert_caution_list = [alertsValues, cautionsValues];

      let getColors = (seriesvalues) => {
        let colors = [];
        let joiningColors = [];

        let count = seriesvalues.length;
        colors = constants.colors.slice(0, count);
        console.log("checking colors", colors);
        seriesvalues.forEach((param) => {
          if (param.name == "Alert") {
            joiningColors.push(constants.exxonRed);
          } else if (param.name == "Caution") {
            joiningColors.push(constants.darkOrange);
          } else {
            joiningColors.push(colors.shift());
          }
        });
        console.log("joiningColors ", joiningColors);

        return joiningColors;
      };
      let getAnnotationData = (value) => {
        let originalValue = value;
        console.log("checking annotation values", value);
        if (value == "null") {
          value = -Infinity;
        } else {
          value = originalValue;
        }
        return value;
      };

      let getYAxisProperties = (seriesvalues) => {
        let yaxisArray = [];
        let multi_yaxis_display_array = [];
        console.log("checking values for data=>", seriesvalues);
        console.log("chartMinMaxObj is =>", chartMinMaxObj);
        console.log("dbc_params_map here is ", dbc_params_map);
        let count = 0;
        seriesvalues.forEach((param) => {
          if (param.name == "Alert" || param.name == "Caution") {
            return;
          }
          console.log("checking param.name=>", param.name);
          let dbc_parameters_obj = {};
          if (dbc_params_map) {
            dbc_parameters_obj = dbc_params_map.get(param.name);
            console.log("dbc_parameters_obj=>", dbc_parameters_obj);
          }

          let usual = {};
          let yaxis_title = "";
          if (
            dbc_parameters_obj != undefined &&
            "yaxis_title" in dbc_parameters_obj
          ) {
            yaxis_title = dbc_parameters_obj["yaxis_title"];
          }
          if (
            dbc_parameters_obj != undefined &&
            "series_type" in dbc_parameters_obj
          ) {
            param.type = dbc_parameters_obj["series_type"];
          }
          usual.title = {
            text: yaxis_title,
          };

          let decimals = 0;

          if (
            dbc_parameters_obj != undefined &&
            "yaxis_decimals" in dbc_parameters_obj
          ) {
            usual.decimalsInFloat = dbc_parameters_obj["yaxis_decimals"];
            decimals = dbc_parameters_obj["yaxis_decimals"];
          } else {
            usual.decimalsInFloat = 0;
          }

          if (
            dbc_parameters_obj != undefined &&
            "max_value" in dbc_parameters_obj
          ) {
            usual.max = dbc_parameters_obj["max_value"];
          }
          if (
            dbc_parameters_obj != undefined &&
            "min_value" in dbc_parameters_obj
          ) {
            usual.min = dbc_parameters_obj["min_value"];
          }

          if (
            dbc_parameters_obj != undefined &&
            "yaxis_force_nice_scale" in dbc_parameters_obj
          ) {
            usual.forceNiceScale = dbc_parameters_obj["yaxis_force_nice_scale"];
            if (dbc_parameters_obj["yaxis_force_nice_scale"] == false) {
              if ("yaxis_tick_amount" in dbc_parameters_obj) {
                usual.tickAmount = dbc_parameters_obj["yaxis_tick_amount"];
              }
            }
          } else {
            usual.forceNiceScale = true;
          }

          if (
            dbc_parameters_obj != undefined &&
            "yaxis_scale_series_name" in dbc_parameters_obj
          ) {
            usual.seriesName = dbc_parameters_obj["yaxis_scale_series_name"];
          }
          if (
            dbc_parameters_obj != undefined &&
            "yaxis_scale_display" in dbc_parameters_obj
          ) {
            usual.show = dbc_parameters_obj["yaxis_scale_display"];
          }
          if (
            dbc_parameters_obj != undefined &&
            "display_opposite" in dbc_parameters_obj
          ) {
            usual.opposite = dbc_parameters_obj["display_opposite"];
          }

          usual.showAlways = true;

          usual.labels = {
            // formatter: function (val) {
            //   return parseInt(val) === val ? val : ''
            // }
            formatter: function(val) {
              console.log("checking de", decimals);
              return val;
            },
            // formatter: (value) => Math.floor(value),
          };

          if (usual.show == true) {
            yaxisArray.push(usual);
          }

          {
            multi_yaxis_display_array.push(usual);
            count += 1;
            console.log(count);
          }
        });

        console.log("yaxis array is ", yaxisArray);
        if (yaxisArray.length == 1) {
          return yaxisArray;
        } else {
          return multi_yaxis_display_array;
        }
      };
      let timestampsLt = [];
      let chartData = {
        id: chartname,
        chartTitle: chartname,
        chartOptions: {
          colors: getColors(seriesvalues),

          chart: {
            animations: {
              enabled: false,
            },
            height: "230px",
            type: "line",
            zoom: {
              type: "x",
              enabled: true,
              autoScaleYaxis: false,
            },
            toolbar: {},
          },
          annotations: {
            yaxis: [
              {
                y: getAnnotationData(highAlertValue) || -Infinity,
                borderColor: "#ff0000",
                borderWidth: 3,
                label: {
                  borderColor: "#cc0066",
                  style: {
                    color: "#fff",
                    width: 2,
                    background: "#cc0066",
                  },
                },
              },
              {
                y: getAnnotationData(highCautionValue) || -Infinity,
                borderColor: "#FFA500",
                borderWidth: 3,
                label: {
                  borderColor: "#A52A2A",
                  style: {
                    color: "#fff",
                    width: 2,
                    background: "#cc0066",
                  },
                },
              },
              {
                y: getAnnotationData(lowAlertValue) || -Infinity,
                borderColor: "#ff0000",
                borderWidth: 3,
                label: {
                  borderColor: "#996633",
                  style: {
                    color: "#fff",
                    width: 2,
                    background: "#996633",
                  },
                },
              },
              {
                y: getAnnotationData(lowCautionValue) || -Infinity,
                borderColor: "#FFA500",
                borderWidth: 3,
                label: {
                  borderColor: "#996633",
                  style: {
                    color: "#fff",
                    width: 2,
                    background: "#996633",
                  },
                },
              },
            ],
          },

          legend: {
            position: "bottom",
            horizontalAlign: "center",
            showForSingleSeries: true,

            style: {},
          },

          xaxis: {
            title: {
              text: "Time",
              align: "right",
              style: {
                color: "#484848",
                fontSize: "14px",
                fontWeight: "bold",
              },
            },
            type: "datetime",
            categories: timestampsLt,
            datetimeUTC: false,
            labels: {
              datetimeUTC: false,
            },
            axisBorder: {
              show: true,
              color: "#78909C",
              height: 1,
              width: "100%",
              offsetX: 0,
              offsetY: 0,
            },
          },
          grid: {
            borderColor: "#f1f1f1",
          },
          yaxis: getYAxisProperties(seriesvalues),
          stroke: {
            width: [2, 2, 2],
            curve: "straight",
          },
          tooltip: {
            shared: true,
            intersect: false,
            x: {
              format: "dd MMM - HH : mm: ss",
            },
          },
        },
        series: seriesvalues,
        markers: {
          size: 0,
        },
      };
      console.log("after creating chart data", chartData);
      return [chartData, alert_caution_list];
    },
    intervalFetchData: function(
      machine_id,
      startDate,
      endDate,
      show,
      grp_show,
      check
    ) {
      console.log(
        "checking values for sure",
        machine_id,
        startDate,
        endDate,
        show,
        grp_show,
        check
      );
      this.checkBox = check;
      this.machine_id_Selected = machine_id;
      this.start_date = startDate;
      this.end_date = endDate;
      let count = 0;

      this.searchNew(
        this.machine_id_Selected,
        startDate,
        endDate,
        show,
        grp_show
      );

      if (this.checkBox === true) {
        if (this.prevNowPlaying) {
          clearInterval(this.prevNowPlaying);
        }
        let unix = Math.round(+new Date() / 1000);
        sessionStorage.setItem("realtime_start_date", unix);
        this.getPeriodforSetInterval(this.machine_id_Selected);
        this.prevNowPlaying = setInterval(() => {
          let unix = Math.round(+new Date() / 1000);
          console.log(
            "checking this.interval_frequency al",
            this.interval_frequency
          );
          if (!this.recordNotFound) {
            this.start_date =
              unix -
                Number(this.$config.extensionOfSetIntervalSeconds) / 1000 || 60;
          }

          this.end_date = unix;

          this.getRealTimeEnergyData(
            this.machine_id_Selected,
            this.start_date,
            this.end_date,
            show,
            grp_show
          );

          count += 1;
          let date = new Date();
          console.log("checking count ", count, "timestamp", date.getSeconds());
        }, Number(this.$config.extensionOfSetIntervalSeconds) || 60000);
        //  this.interval_frequency (replace with hardcode and when necesary make it hardocde for testing)
      } else if (this.checkBox === false) {
        clearInterval(this.prevNowPlaying);
        this.getPeriodforSetInterval(this.machine_id_Selected);
      }
    },
  },
};
</script>

<style scoped>
@import "../assets/fonts/style.css";

@media screen and (min-width: 600px) {
  #div2 {
    display: none;
  }
  #ins1 {
    display: none;
  }
}

/* On screens that are 600px wide or less, the background color is olive */
@media screen and (max-width: 600px) {
  #div1 {
    display: none;
  }
  #ins2 {
    display: none;
  }
}
.v-list-item--link {
  border-bottom: 1px solid #e1e1e1;
}

.row.bg-white.mydrop {
  padding: 13px;
}
.my-datelist2.v-list {
  border-top: 1px solid #e1e1e1 !important;
}

.my-datelist2 .v-list-item__title {
  align-self: center;
  font-size: 0.91rem;
  color: #7e84a3;
}

.my-datelist2 .v-list-item {
  min-height: 34px;
}
.my-datelist2 .v-list-item:hover {
  background-color: #e9e9e9;
}

.my-datelist2 .v-list-item:hover .v-list-item__title {
  color: #0c479d;
}

.my-datelist2.v-sheet.v-list {
  padding: 0;
  /* margin-top: -35px; */
}

.btn-square2 {
  height: 48px !important;
  min-width: 48px !important;
  padding: 0 !important;
  border-radius: 5px !important;
}
.insights_ideal {
  color: #484848;
  font-size: 14px;
  font-weight: bold;
}
.insights_alert {
  color: #fe000c;
  font-size: 14px;
  font-weight: bold;
}
.insights_caution {
  color: #edfe00;
  font-size: 14px;
  font-weight: bold;
}
.insights_normal {
  color: #228517a4;
  font-size: 14px;
  font-weight: bold;
}
.insights_param {
  color: #484848;
  font-size: 16px;
  font-weight: bold;
}
.chartClass {
  border-style: solid;
  border-radius: 10px;
  border-color: #a7a7a7;
  border-width: thin;
  width: 460px;
  background-color: #fafafa;
  height: 270px;
  margin-right: 4px;
}
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
</style>
